type PrayerStatusType = {
    unknown: '1',
    active: '2', 
    answered: '3', 
    revisit: '4',
    deleted: '5',
}
export const PrayerStatus: PrayerStatusType = {
    unknown: '1',
    active: '2', 
    answered: '3', 
    revisit: '4',
    deleted: '5',
}

export type PrayerStatusValues = typeof PrayerStatus[keyof typeof PrayerStatus]

export const AllPrayerStatus: PrayerStatusValues[] = Array.from(Object.values(PrayerStatus));

export const PrayerStatusNames:{ [key in PrayerStatusValues]: string } = {
    [PrayerStatus.unknown]: 'Unknown',
    [PrayerStatus.active]: 'Active',
    [PrayerStatus.answered]: 'Answered',
    [PrayerStatus.revisit]: 'Revisit',
    [PrayerStatus.deleted]: 'Deleted',
}

export default PrayerStatus;